module.exports = __webpack_public_path__ + "static/img/RAZ-D_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAZ-D_1.png
// module id = KJ1d
// module chunks = 0